const usePeopleCredit = ({ creditReportData }) => {
  const currentDirectorsLength = creditReportData?.currentDirectors?.length || 0;
  const previousDirectorsLength = creditReportData?.previousDirectors?.length || 0;
  const shareHoldersLength = creditReportData?.shareHolders?.length || 0;
  const activePersonsWithSignificantControlLength =
    creditReportData?.personsWithSignificantControl?.active?.length || 0;
  const ceasedPersonsWithSignificantControlLength =
    creditReportData?.personsWithSignificantControl?.ceased?.length || 0;
  const previousDirectorsList = creditReportData?.previousDirectors ?? [];
  const shareholdersList = creditReportData?.shareHolders ?? [];
  const collapsePrintSuffix = 'print';

  return {
    currentDirectorsLength,
    previousDirectorsLength,
    shareHoldersLength,
    activePersonsWithSignificantControlLength,
    ceasedPersonsWithSignificantControlLength,
    previousDirectorsList,
    shareholdersList,
    collapsePrintSuffix,
  };
};

export default usePeopleCredit;
